import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "freeze-screen-msg-div"
}
const _hoisted_3 = { class: "freeze-screen-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_LatestNews = _resolveComponent("LatestNews")!
  const _component_LicenseDetails = _resolveComponent("LicenseDetails")!
  const _component_OnboardingInstructions = _resolveComponent("OnboardingInstructions")!
  const _component_TrialPackageIndicator = _resolveComponent("TrialPackageIndicator")!
  const _component_TopNavBar = _resolveComponent("TopNavBar")!
  const _component_LeftMenuPanel = _resolveComponent("LeftMenuPanel")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isFreezeScreenMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("App.FreezeScreenMsg")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({addVideoOverlay: _ctx.isaddVideoOverlay})
    }, null, 2),
    _createVNode(_component_loading, {
      "show-loading": _ctx.showLoading,
      "border-color": _ctx.ViewModel.ApplicationInformation.TopNavBackgroundColor,
      "loader-opacity": 1
    }, null, 8, ["show-loading", "border-color"]),
    (_ctx.showLatestNewsPopup)
      ? (_openBlock(), _createBlock(_component_LatestNews, {
          key: 1,
          "show-modal-popup": _ctx.showLatestNewsPopup,
          "border-color": _ctx.ViewModel.ApplicationInformation.TopNavBackgroundColor,
          onClosePopup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.CloseLatestNewsPopup()))
        }, null, 8, ["show-modal-popup", "border-color"]))
      : _createCommentVNode("", true),
    (_ctx.showLicenseDetailsPopup)
      ? (_openBlock(), _createBlock(_component_LicenseDetails, {
          key: 2,
          "show-modal-popup": _ctx.showLicenseDetailsPopup,
          "application-id": _ctx.ViewModel.ApplicationInformation.Id,
          "border-color": _ctx.ViewModel.ApplicationInformation.TopNavBackgroundColor,
          "is-logged-in-user-super-admin": _ctx.isLoggedInUserSuperAdmin,
          "is-application-on-new-package": _ctx.ViewModel.ApplicationInformation.IsApplicationOnNewPackage,
          "is-meet-app-live-enabled": _ctx.ViewModel.ApplicationInformation.EnableMeetAppLive,
          onCloseLicensePopup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closePopup($event)))
        }, null, 8, ["show-modal-popup", "application-id", "border-color", "is-logged-in-user-super-admin", "is-application-on-new-package", "is-meet-app-live-enabled"]))
      : _createCommentVNode("", true),
    (_ctx.showOnboardingPopup)
      ? (_openBlock(), _createBlock(_component_OnboardingInstructions, {
          key: 3,
          "logged-in-user-name": _ctx.GetLoggedInUserName(),
          "show-modal-popup": _ctx.showOnboardingPopup,
          onClosePopup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CloseOnboardingPopup()))
        }, null, 8, ["logged-in-user-name", "show-modal-popup"]))
      : _createCommentVNode("", true),
    (_ctx.ViewModel.ApplicationInformation.IsCurrentPackageTrial)
      ? (_openBlock(), _createBlock(_component_TrialPackageIndicator, {
          key: 4,
          "application-id": _ctx.ViewModel.ApplicationInformation.Id,
          "show-trail-indicator": _ctx.ViewModel.ApplicationInformation.IsCurrentPackageTrial,
          "package-expiration-pending-days": _ctx.ViewModel.ApplicationInformation.PackageExirationPendingDays,
          "is-application-on-new-package": _ctx.ViewModel.ApplicationInformation.IsApplicationOnNewPackage
        }, null, 8, ["application-id", "show-trail-indicator", "package-expiration-pending-days", "is-application-on-new-package"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TopNavBar, {
      "view-model": _ctx.ViewModel,
      "app-color": _ctx.AppColor,
      "menu-items": _ctx.leftMenuTabs,
      "icon-images": _ctx.leftMenuTabsIconImages,
      "app-font-color": _ctx.AppFontColor,
      "app-and-background-color": _ctx.AppColorAndBackgroundColor,
      "active-component": _ctx.activeComponent,
      onShowLicenseDetails: _ctx.OpenLicenseDescription,
      onShowLatestNewsDialog: _ctx.OpenNewsFlash,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggledNav = !_ctx.toggledNav))
    }, null, 8, ["view-model", "app-color", "menu-items", "icon-images", "app-font-color", "app-and-background-color", "active-component", "onShowLicenseDetails", "onShowLatestNewsDialog"]),
    _createElementVNode("div", {
      id: "main-container",
      class: "main-container",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.OnMainContainerClick()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["main-container-inner", {'z-index-0': !_ctx.isFreezeScreenMsg}])
      }, [
        _createVNode(_component_LeftMenuPanel, {
          "view-model": _ctx.ViewModel,
          "show-left-menu-bar": _ctx.isLeftMenuBarShow,
          "menu-items": _ctx.leftMenuTabs,
          "icon-images": _ctx.leftMenuTabsIconImages,
          "active-component": _ctx.activeComponent
        }, null, 8, ["view-model", "show-left-menu-bar", "menu-items", "icon-images", "active-component"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.mainContentClass)
        }, [
          _createVNode(_component_router_view)
        ], 2)
      ], 2)
    ])
  ]))
}